import { render, staticRenderFns } from "./DanhSachPrdGoiDichVu.vue?vue&type=template&id=3a70e6e2&scoped=true&"
import script from "./DanhSachPrdGoiDichVu.vue?vue&type=script&lang=js&"
export * from "./DanhSachPrdGoiDichVu.vue?vue&type=script&lang=js&"
import style0 from "./DanhSachPrdGoiDichVu.vue?vue&type=style&index=0&id=3a70e6e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a70e6e2",
  null
  
)

export default component.exports